import { DatasetSizeLimiter } from "@/services/license/license-limiters/base-limiters/dataset-size-limiter";
import { LicenseName } from "@/data/license.data";

export abstract class DefaultDatasetSizeLimiter extends DatasetSizeLimiter {
  private trialFileMbSizeLimit = 10;
  private paidFileMbSizeLimit = 20;

  getPlanLimit(license: LicenseName): number {
    switch (license) {
      case "Trial":
        return this.trialFileMbSizeLimit;
      default:
        return this.paidFileMbSizeLimit;
    }
  }
}
